import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { Collapse, TableCell, TableRow } from '@mui/material';

import OnCreateIcon from '../../../../icons/OnCreateIcon';
import { setCurrentVacancy } from '../../../../store/recruitmentService';

import JobOffersDetails from './JobOffersDetails';

import classes from '../../../../commonStyles/tables.module.css';

const dropdownStyles = {
    paddingBottom: 0,
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
    borderTop: 'none',
    borderBottom: 'none'
};

const JobOffersTableRow = ({
    row,
    roles,
    acceptedRoles,
    toggleDropdown,
    openId,
    onPlacementEditor
}) => {
    // HOOKS
    const dispatch = useDispatch();

    // LOCAL STATE
    const [open, setOpen] = useState(false);
    const [updatedRow, setUpdatedRow] = useState({});

    // STORE STATE
    const successMessage = useSelector((state) => state.entities.formsState.successMessage);

    // EVENT HANDLER CALLBACKS
    const onAddPlacement = (row) => {
        dispatch(setCurrentVacancy(row));
        onPlacementEditor(true);
    };

    const onToggleDropdown = (e) => {
        if (e.target.nodeName !== 'TD') return;
        toggleDropdown(row.id, e);
        setOpen(open === row.id ? null : row.id);
    };

    // USE EFFECTS
    useEffect(() => {
        setUpdatedRow(row);
    }, [row]);

    useEffect(() => {
        if (openId !== row.id) setOpen(null);
    }, [openId]);

    useEffect(() => {
        if (successMessage === `Job placement has been added: ${row.id}`) {
            setUpdatedRow((prev) => ({ ...prev, placementFound: true }));
        }
    }, [successMessage]);

    // RENDER
    return (
        <>
            <TableRow
                key={row.id}
                hover
                className={`${classes.tableRowStripes} ${classes.oldLace} ${classes.canOpen}`}
                onClick={onToggleDropdown}>
                <TableCell>{row.code}</TableCell>
                <TableCell>{row.title}</TableCell>
                <TableCell>{row.adviser}</TableCell>
                <TableCell>{row.jobSectorName}</TableCell>
                <TableCell>{row.payRate}</TableCell>
                <TableCell>{row.postcodeOrRemote}</TableCell>
                <TableCell align="left">
                    <OnCreateIcon
                        onCreate={() => onAddPlacement(row)}
                        titleString={'Placement'}
                        roles={roles}
                        acceptedRoles={acceptedRoles}
                        active={!updatedRow.placementFound}
                    />
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={dropdownStyles} colSpan={7}>
                    <Collapse in={open === row.id} timeout="auto" unmountOnExit>
                        <JobOffersDetails row={row} onClose={() => setOpen(null)} />
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

JobOffersTableRow.propTypes = {
    row: PropTypes.object,
    roles: PropTypes.arrayOf(PropTypes.string),
    acceptedRoles: PropTypes.arrayOf(PropTypes.string),
    toggleDropdown: PropTypes.func,
    openId: PropTypes.string,
    onPlacementEditor: PropTypes.func
};

export default JobOffersTableRow;
